'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botSessionsFilter = require('./bot-sessions-filter.html');

var _botSessionsFilter2 = _interopRequireDefault(_botSessionsFilter);

var _botSessionsFilter3 = require('./bot-sessions-filter.controller');

var _botSessionsFilter4 = _interopRequireDefault(_botSessionsFilter3);

require('./bot-sessions-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botSessionsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _botSessionsFilter2.default,
  controller: _botSessionsFilter4.default,
  controllerAs: 'vm'
};

exports.default = botSessionsFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/bot-sessions-filter/bot-sessions-filter.component.js
 **/